function catalogText(...values) {
  return String(values.find(Boolean) || '').trim();
}

function catalogEntry(value) {
  const entry = value ?? {};
  return {
    key: catalogText(entry.key, entry.id, entry.value),
    label: catalogText(entry.label, entry.name, entry.key),
    summary: catalogText(entry.summary, entry.description),
    availability: catalogText(entry.availability, 'available') || 'available',
  };
}

export function normalizeCapabilityCatalog(capabilityCatalog = []) {
  return (Array.isArray(capabilityCatalog) ? capabilityCatalog : [])
    .map(catalogEntry)
    .filter((entry) => entry.key && entry.label);
}
